import React from 'react';
import { motion } from 'framer-motion';

const WhyChooseUs: React.FC = () => {
  const stats = [
    { number: '15+', label: 'Projects Completed', icon: '🎯' },
    { number: '98%', label: 'Client Satisfaction', icon: '⭐' },
    { number: '24/7', label: 'Support Available', icon: '🛟' },
    { number: '5+', label: 'Years Experience', icon: '🏆' }
  ];

  const processes = [
    {
      step: '01',
      title: 'Discovery & Strategy',
      description: 'We dive deep into understanding your business goals, target audience, and competitive landscape to create a strategic roadmap for your digital success.'
    },
    {
      step: '02',
      title: 'Design & Prototyping',
      description: 'Our creative team crafts stunning visual designs and interactive prototypes that bring your vision to life while ensuring optimal user experience.'
    },
    {
      step: '03',
      title: 'Development & Testing',
      description: 'Using cutting-edge technologies and best practices, we build robust, scalable solutions with rigorous testing to ensure perfection.'
    },
    {
      step: '04',
      title: 'Launch & Optimization',
      description: 'We handle the seamless deployment and provide ongoing optimization to maximize performance, conversions, and user engagement.'
    },
    {
      step: '05',
      title: 'Training & Handover',
      description: 'We provide comprehensive training for your team and ensure smooth knowledge transfer so you can confidently manage your digital assets.'
    },
    {
      step: '06',
      title: 'Ongoing Support',
      description: 'Continuous monitoring, updates, and technical support to keep your website secure, fast, and performing at its best.'
    }
  ];

  return (
    <motion.section id="why-choose-us" className="why-choose-us" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
      <div className="stats-section">
        <h2>Trusted by Businesses Worldwide</h2>
        <p className="section-subtitle">Our track record speaks for itself. Here's what we've achieved together with our clients.</p>
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-card"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
            >
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="process-section">
        <h2>Our Proven Process</h2>
        <p className="section-subtitle">A systematic approach that ensures quality, efficiency, and outstanding results for every project.</p>
        <div className="process-grid">
          {processes.map((process, index) => (
            <motion.div
              key={index}
              className="process-card"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.8 }}
            >
              <div className="process-index">{process.step}</div>
              <h3>{process.title}</h3>
              <p>{process.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default WhyChooseUs;
